"use strict";
// packages/contracts/src/numero-ptbr.ts — Fase 12, WR-A-04 (compartilhado API + web para a CR-D1-01).
//
// Interpretacao PURA de numero digitado/importado em texto pt-BR, sem "adivinhar" o milhar. O erro classico e tratar "0.125" ou
// "2.500" como milhar (1000x de diferenca): so ha certeza quando o padrao e inequivoco; o resto e devolvido como AMBIGUO
// para o chamador pedir correcao (erro/aviso) em vez de gravar um valor 1000x errado.
//
//   inequivoco (ok):   '1.234,56' '12,5' '1,5' '1234.56' '12.5' '0.125' '1234.567' '1.234.567' '1,234.56' '-3,5'
//   ambiguo:           '1.234' '2.500' '12.345' '123.456' (ponto + exatamente 3 casas, parte inteira sem zero a esquerda, 1..3 digitos)
//   invalido:          '' 'abc' '1,2,3' '1.2.3' '1.23,4' '=1+1'
//
// Regras: virgula unica = decimal (convencao pt-BR); virgula + ponto => o ULTIMO separador e o decimal e o outro precisa formar
// grupos validos de milhar (1..3 digitos e depois grupos de 3); varios pontos = milhar (grupos validos); um ponto = decimal,
// exceto no padrao ambiguo acima.
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpretarNumeroPtBr = interpretarNumeroPtBr;
exports.mensagemNumeroAmbiguo = mensagemNumeroAmbiguo;
const GRUPOS_DE_MILHAR = /^\d{1,3}(?:SEP\d{3})+$/;
function gruposValidos(parteInteira, separador) {
    const escapado = separador === '.' ? '\\.' : ',';
    return new RegExp(GRUPOS_DE_MILHAR.source.replace('SEP', escapado)).test(parteInteira);
}
function ok(texto, sinal) {
    const valor = Number(texto) * sinal;
    return Number.isFinite(valor) ? { tipo: 'ok', valor } : { tipo: 'invalido' };
}
/** Interpreta o texto de um numero pt-BR (ver o cabecalho do arquivo para as regras e os casos ambiguos). */
function interpretarNumeroPtBr(entrada) {
    let texto = entrada.replace(/R\$/gi, '').replace(/\s+/g, '');
    if (texto === '') {
        return { tipo: 'vazio' };
    }
    let sinal = 1;
    if (texto.startsWith('-')) {
        sinal = -1;
        texto = texto.slice(1);
    }
    if (!/^[\d.,]+$/.test(texto) || !/^\d/.test(texto)) {
        return { tipo: 'invalido' };
    }
    const virgulas = texto.split(',').length - 1;
    const pontos = texto.split('.').length - 1;
    if (virgulas > 0 && pontos > 0) {
        const ultimaVirgula = texto.lastIndexOf(',');
        const ultimoPonto = texto.lastIndexOf('.');
        const decimalEVirgula = ultimaVirgula > ultimoPonto;
        const separadorDecimal = decimalEVirgula ? ',' : '.';
        const separadorMilhar = decimalEVirgula ? '.' : ',';
        const [inteira, decimal, ...resto] = texto.split(separadorDecimal);
        if (resto.length > 0 || decimal === undefined || !/^\d+$/.test(decimal) || !inteira || !gruposValidos(inteira, separadorMilhar)) {
            return { tipo: 'invalido' };
        }
        return ok(`${inteira.split(separadorMilhar).join('')}.${decimal}`, sinal);
    }
    if (virgulas > 0) {
        // Convencao pt-BR: a virgula e o decimal. Mais de uma virgula nao e numero ('1,2,3', '1,234,567').
        if (virgulas > 1 || !/^\d+,\d+$/.test(texto)) {
            return { tipo: 'invalido' };
        }
        return ok(texto.replace(',', '.'), sinal);
    }
    if (pontos > 1) {
        return gruposValidos(texto, '.') ? ok(texto.replace(/\./g, ''), sinal) : { tipo: 'invalido' };
    }
    if (pontos === 1) {
        const [inteira, decimal] = texto.split('.');
        if (!/^\d+$/.test(inteira) || !/^\d+$/.test(decimal)) {
            return { tipo: 'invalido' };
        }
        // Ponto + exatamente 3 casas: milhar ("1.234" = 1234) ou decimal ("1.234" = 1,234)? Um grupo de milhar nunca comeca com
        // zero e tem de 1 a 3 digitos; fora disso so pode ser decimal.
        if (decimal.length === 3 && /^[1-9]\d{0,2}$/.test(inteira)) {
            const comoDecimal = Number(texto) * sinal;
            const comoMilhar = Number(`${inteira}${decimal}`) * sinal;
            return { tipo: 'ambiguo', comoMilhar, comoDecimal };
        }
        return ok(texto, sinal);
    }
    return ok(texto, sinal);
}
/** Mensagem padrao para o numero ambiguo (a API grava na linha da previa; a web exibe no campo). */
function mensagemNumeroAmbiguo(entrada, resultado) {
    const formatar = (numero) => numero.toLocaleString('pt-BR', { maximumFractionDigits: 6 });
    return `Número ambíguo "${entrada.trim()}": pode ser ${formatar(resultado.comoDecimal)} ou ${formatar(resultado.comoMilhar)}. Use vírgula para decimais e nenhum ponto de milhar.`;
}
//# sourceMappingURL=numero-ptbr.js.map